import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsSubagentNotEnoughMoney } from '../../selectors/publishInfo';
import { setIsSubagentNotEnoughMoney, setPlacingMoneySource, EMoneySource } from '../../redux/reducers';
import { saveDraft } from '../../actions/draft';

import { SubagentNotEnoughMoneyModal } from './SubagentNotEnoughMoneyModal';

export const SubagentNotEnoughMoneyModalContainer = () => {
  const dispatch = useDispatch();
  const isSubagentNotEnoughMoney = useSelector(selectIsSubagentNotEnoughMoney);

  const closeModal = React.useCallback(() => {
    dispatch(setIsSubagentNotEnoughMoney(false));
  }, [dispatch]);

  const setSelfMoneySource = React.useCallback(() => {
    dispatch(setPlacingMoneySource(EMoneySource.Self));
    closeModal();
  }, [dispatch, closeModal]);

  const saveDraftHandler = React.useCallback(() => {
    dispatch(saveDraft());
    closeModal();
  }, [dispatch, closeModal]);

  const title = 'Нет денег на счёте агентства';

  return (
    <SubagentNotEnoughMoneyModal
      isOpen={isSubagentNotEnoughMoney}
      title={title}
      onClose={closeModal}
      onChangeMoneySource={setSelfMoneySource}
      onSaveDraft={saveDraftHandler}
    />
  );
};
